module.exports = __webpack_public_path__ + "static/media/footer_tawuniya_logo.4bab7779.svg";